<template>
    <div class="row">

        <div v-if="numList <= 0" class="main-container">
            <section class="section">
                <div class="sc-inner">
                    <div class="container">

                        <div class="sc-content">

                            <div class="no-result-wrap">
                                <div class="no-result-content">
                                    <i class="ic ic-search-question"></i>
                                    <h2 class="title">ไม่พบผลลัพธ์การค้นหา</h2>
                                    <p class="desc">กรุณาเปลี่ยนคำค้นหา <span class="nowrap">หรือทำการเลือกประเภทใหม่อีกครั้ง</span></p>
                                </div>
                            </div>

                        </div>

                    </div>
                </div>
            </section>
        </div>

        <div v-else v-for="(val, key) in list" :key="key" :class="{'hidden-device': (val.index && val.index > 1), 'last-col-device': falase}" class="col col-xs-12 col-md-3">
            <div :class="{'alignment': (val.bkk_group == 'tags'), 'fullwidth': (val.bkk_group != 'tags')}" class="thumbnail">
                <div class="wrap">
                    <div class="image">
                        <a :href="val.url"><img v-lazy="val.thumbnail" :srcset="val.thumbnailx2 + ' 2x'" alt=""></a>
                        <div v-if="val.is_sponsor" class="label-box"><a class="label label-sponsored">Sponsored</a></div>
                    </div>
                    <div class="meta">
                        <div v-if="val.is_editorpick || val.is_newlyopen" class="pick-box">
                            <span pickbox-rotate :class="{'editor': val.is_editorpick, 'newly': (!val.is_editorpick && val.is_newlyopen)} + '-active'" class="pick-anim">
                                <a v-if="val.is_editorpick" class="pick editor" href="#"><i class="ic ic-heart"></i><span class="ic-name">Editor's Pick</span></a>
                                <a v-if="val.is_newlyopen" class="pick newly" href="#" ><i class="ic ic-newly"></i><span class="ic-name">Newly Opened</span></a>
                            </span>
                        </div>
                        <h3 class="title"><a :href="val.url">{{ val.name }}</a></h3>
                        <div class="info" v-html="val.location_tags"></div>
                        <div class="category" v-html="val.category_tags"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from 'vue'

import VueLazyload from 'vue-lazyload'
Vue.use(VueLazyload)

export default {
  name: 'ItemSmallList',
  data () {
    return {
      list: window._item_lists
    }
  },
  computed: {
    numList () {
      return this.list.length - 1
    }
  }
}
</script>
